import * as React from 'react';
import { clsx } from 'clsx';
import { memo } from "react";
import { Pagination as PaginationHeadless } from "react-headless-pagination";
import IconFontAwesome from "./iconFontAwesome";

type Props = Readonly<{
	currentPage: number,
	totalPages: number,
	setCurrentPage: (page: number) => void,
	className?: string,
}>

export function getTotalPages(count = 0, perPage = 25) {
	let total = Math.ceil(count / perPage);
	if (total < 1 || isNaN(total)) {
		total = 1;
	}
	return total;
}

function Pagination({
	currentPage = 0,
	totalPages = 1,
	setCurrentPage,
	className = '',
	...otherProps
}: Props) {
	return (
		<PaginationHeadless
			currentPage={currentPage}
			totalPages={totalPages}
			setCurrentPage={setCurrentPage}
			className={clsx("flex justify-center", className)}
			truncableText="..."
			truncableClassName="mx-2"
			edgePageCount={2}
			middlePagesSiblingCount={2}
			{...otherProps}
		>
			<PaginationHeadless.PrevButton className="mr-6 min-w-9">
				<IconFontAwesome className="icon-chevron-left"/>
			</PaginationHeadless.PrevButton>

			<nav className="flex items-center my-0 py-0">
				<ul className="flex items-center justify-center">
					<PaginationHeadless.PageButton
						activeClassName="bg-grey-300 bg-primary-admin-200 border-primary-admin-400 shadow-inner cursor-default"
						inactiveClassName="bg-grey-100 cursor-pointer"
						className="button mx-1 min-w-9 text-center"
					/>
				</ul>
			</nav>

			<PaginationHeadless.NextButton className="ml-6 min-w-9">
				<IconFontAwesome className="icon-chevron-right"/>
			</PaginationHeadless.NextButton>
		</PaginationHeadless>
	);
}

export default memo(Pagination);
